import { connect } from 'react-redux';
import PengisianNilaiPsik from '../../../views/Kurikulum/Ulangan/PengisianNilaiPsik.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}
export default connect(null, mapDispatchToProps)(PengisianNilaiPsik);
